import { render, staticRenderFns } from "./EventDetailsGate.vue?vue&type=template&id=0c663c13&"
import script from "./EventDetailsGate.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsGate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports